import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AppConfig } from '@core/services/app-config.service';
import { select, Store } from '@ngrx/store';
import { getEmail } from '@core/states/user.state';
import { getPublicSettings } from '@store/common';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[octFeatureFlag]'
})
export class FeatureFlagDirective implements OnInit, OnDestroy {
  @Input('octFeatureFlag') featureFlag: string;
  private destroyed$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private store: Store<any>
  ) {
  }

  ngOnInit(): void {
    if (this.featureFlag) {
      combineLatest([
        this.store.pipe(select(getEmail)),
        this.store.pipe(select(getPublicSettings)),
      ])
        .pipe(takeUntil(this.destroyed$))
        .subscribe(([email, settings]) => {
          const isEnabled = AppConfig.isEnabled(this.featureFlag, settings);
          this.el.nativeElement.hidden = email !== 'support@octopai.com' ? !isEnabled : false;
        });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
